import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import {TaskNotificationService} from '@app/services/task-notification.service';
import {TaskLogsComponent} from '@app/_components/task-logs/task-logs.component';
import {SbModalService} from '@app/_components/unified/sb-modal/sb-modal.service';

/**
 * Header icon for background tasks (influencer imports, registration platform syncs and bulk deletes).
 * Active while a relevant task is running, greyed out otherwise, badged when a task finished
 * that the user has not looked at yet. Clicking opens the task log list.
 */
@Component({
  selector: 'app-task-notification',
  templateUrl: './task-notification.component.html',
  styleUrls: ['./task-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskNotificationComponent {
  taskNotification = inject(TaskNotificationService);
  private readonly sbModal = inject(SbModalService);


  get label(): string {
    if (this.taskNotification.hasRunning) {
      const count = this.taskNotification.runningCount;
      return `${count} task${count === 1 ? '' : 's'} running — click to view the task log`;
    }
    if (this.taskNotification.hasUnseenDone) {
      return 'A task finished — click to view the task log';
    }
    return 'No tasks running — click to view the task log';
  }

  openTaskLogs() {
    this.taskNotification.markSeen();
    const modalRef = this.sbModal.openComponent(TaskLogsComponent, {
      centered: false,
      size: 'xl',
      keyboard: true
    }, {
      data: {
        campaign_id: '',
        influencer_type_id: '',
        project_id: this.taskNotification.openProjectId || '',
        // the notification list is not limited to one task type or one platform
        action: 'all',
        registration_platform_id: 'all',
        own_or_project: true
      },
    });
    // Anything that completed while the list was open counts as acknowledged too
    const onClose = () => {
      this.taskNotification.markSeen();
      this.taskNotification.loadSummary();
    };
    modalRef.result.then(onClose, onClose);
  }
}
